import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { sourceLabel, formatNumber, SOURCE_COLORS } from "./analyticsFormat";

// 0025: distinct CATEGORICAL colors (blue/teal/violet) — not traffic-light, not brand brown.
const COLORS = SOURCE_COLORS;

// 0024: orders-by-source for the current month (spec 0005 attribution).
const SourceBreakdownChart = ({ data }) => {
  const chartData = (data || []).map((d) => ({
    name: sourceLabel(d.source),
    value: d.orders,
  }));
  const total = chartData.reduce((s, d) => s + d.value, 0);

  return (
    <div className="analyticsChartCard">
      <h3 className="analyticsCardTitle">הזמנות לפי מקור (החודש)</h3>
      {total === 0 ? (
        <p className="analyticsEmpty">אין הזמנות החודש</p>
      ) : (
        <ResponsiveContainer width="100%" height={360}>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={90}
              label={(entry) => `${entry.name}: ${formatNumber(entry.value)}`}
            >
              {chartData.map((entry, index) => (
                <Cell key={index} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => formatNumber(value)} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default SourceBreakdownChart;
